<script setup lang="ts">
/**
 * The scene of the empty states of Lijstkaart, algemene standaard: the scene VListCard draws when a screen gives no scene of its own (illustration set, board AutomationsOther).
 * VEmptyIllustration draws the ground and the badge of the state around it.
 */
</script>

<template>
  <g data-scene="generic-list">
    <rect
      x="40"
      y="46"
      width="120"
      height="72"
      rx="8"
      fill="#FFFFFF"
      stroke="#BDBDBD"
      stroke-width="1.6"
      stroke-linejoin="round"
    />
    <rect
      x="48"
      y="54"
      width="40"
      height="6"
      rx="3"
      fill="#E0E0E0"
    />
    <path d="M40 64h120" stroke="#EEEEEE" stroke-width="1.4" />
    <circle cx="56" cy="76" r="6" fill="#C8E6C9" />
    <rect
      x="68"
      y="73"
      width="52"
      height="6"
      rx="3"
      fill="#E0E0E0"
    />
    <path d="M40 88h120" stroke="#EEEEEE" stroke-width="1.4" />
    <circle
      cx="56"
      cy="98"
      r="6"
      fill="none"
      stroke="#E0E0E0"
      stroke-width="1.4"
      stroke-dasharray="2.5 2.5"
    />
    <rect
      x="68"
      y="95"
      width="44"
      height="6"
      rx="3"
      fill="none"
      stroke="#E0E0E0"
      stroke-width="1.2"
      stroke-dasharray="3 3"
    />
    <path d="M40 108h120" stroke="#EEEEEE" stroke-width="1.4" />
    <rect
      x="48"
      y="111"
      width="30"
      height="4"
      rx="2"
      fill="#EEEEEE"
    />
  </g>
</template>
